import React from 'react';

export default function Hero({ affiliateLink, handleCTA })
{
    return (
    <header className="py-5 py-lg-6 bg-white" id="top">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-7">
              <h1 className="display-5 fw-bold lh-1">Domine o seu tempo e recupere o controle da sua rotina — mesmo com mil tarefas por dia.</h1>
              <p className="lead mt-3 text-secondary">Um método simples e comprovado para transformar sua produtividade e alcançar seus objetivos com clareza, foco e disciplina.</p>
              <div className="d-flex flex-wrap gap-2 mt-3">
                <a href={affiliateLink} onClick={handleCTA} className="btn btn-primary btn-lg">Quero Organizar Minha Rotina</a>
                <a href="#beneficios" className="btn btn-outline-secondary btn-lg">Ver como funciona</a>
              </div>
              <div className="d-flex align-items-center gap-3 mt-4 text-muted small">
                <span className="d-inline-flex align-items-center"><i className="bi bi-shield-check me-2"></i>Pagamento seguro via Eduzz</span>
                <span className="d-inline-flex align-items-center"><i className="bi bi-arrow-repeat me-2"></i>Garantia 7 dias</span>
                <span className="d-inline-flex align-items-center"><i className="bi bi-phone me-2"></i>Acesso imediato</span>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="card shadow-sm border-0">
                <div className="card-body p-4">
                  <h5 className="card-title fw-semibold mb-3">O que você verá no treinamento</h5>
                  <ul className="list-unstyled mb-4">
                    <li className="mb-2">✅ Planeje seu dia em <strong>10 minutos</strong></li>
                    <li className="mb-2">✅ Elimine distrações e mantenha <strong>foco profundo</strong></li>
                    <li className="mb-2">✅ Crie hábitos consistentes e realistas</li>
                    <li className="mb-2">✅ Aumente energia e clareza mental</li>
                  </ul>
                  <a href={affiliateLink} onClick={handleCTA} className="btn btn-primary w-100">Quero Acessar Agora</a>
                  <p className="text-muted small mt-3 mb-0">Sem riscos: garantia incondicional de 7 dias via Eduzz.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
}